function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  d: "M0 0h31.57v28.35H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.94 14.76L3.43 6.24H11l4.37 6.09 5.67-6.09h7.11l-8.29 8.52 8.85 8.85h-7.89l-5.42-6-5.54 6h-7.2z",
  fill: "#fff"
})));

function SvgRatingX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.57 28.35"
  }, props), _ref);
}

export default SvgRatingX;